import React from 'react';
import SlotManager from './components/SlotManager';

const ManageSlotsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SlotManager />
    </div>
  );
};

export default ManageSlotsPage;
